// extracted by mini-css-extract-plugin
export var numpadContainer = "_hq-1";
export var phoneButton = "_hq-0";